import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=45914cf9&scoped=true&"
import script from "./DocumentUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUpload.vue?vue&type=style&index=0&id=45914cf9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45914cf9",
  null
  
)

component.options.__file = "DocumentUpload.vue"
export default component.exports